import { render, staticRenderFns } from "./IFIntro.vue?vue&type=template&id=22c8071b"
import script from "./IFIntro.vue?vue&type=script&lang=js"
export * from "./IFIntro.vue?vue&type=script&lang=js"
import style0 from "./IFIntro.vue?vue&type=style&index=0&id=22c8071b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports